import { Component, Link, withState } from '@mna/react'
import LoadingScreen from 'features/LoadingScreen'
import kebabCase from '@mna/utils/kebabCase'

import CareOptionsTitle from 'pages/find-care-options/care-options/Title'
import CareOptionsView from 'pages/find-care-options/care-options/View'
import scoreResults from 'server/triage/actions/test/getScoreFromAnswersResProcessed'

//import testData from 'server/triage/actions/test/generateRecommendedCareOptionsRes'
//const { recommendedCareOptions } = testData

const careOptionsWithoutLocations = [
  'telemedicine', 'concierge-care', 'house-visit'
]


const CareOptions = ({
  store,
  state, actions, history, previousStepName, nextStepName,
  cards, numberOfCards,
  viewMode, toggleViewMode,
  selectCareOption, goCareOption
}) =>
  <div className="my-3 mx-2 text-center">

    <CareOptionsTitle {...{ toggleViewMode, viewMode, numberOfCards }} />

    {/* <LoadingScreen isLoading={store.state.isLoading} minDuration={0}> */}
    <CareOptionsView
      {...{ cards, numberOfCards, viewMode, goCareOption }}
      onChange={
        selectCareOption
        /*({ alt, value }) =>
          actions.setTriageRequest({
            selectedCareOptionName: alt,
            selectedCareOptionScore: value,
          })*/
      }
    />
    {/* </LoadingScreen> */}

  </div>

export default withState({

  state: {
    isLoading: true,
    viewMode: 'carousel'
  },

  actions: {
    toggleViewMode: ({ store }) => store.setState({
      viewMode: store.state.viewMode==='carousel' ? 'list' : 'carousel'
    }),
    selectCareOption: ({ alt, value, store }) => {
      const { actions } = store.props
      actions.setTriageSelectedCareOption({ name: alt, score: value })
    },
    goCareOption: ({ store, alt, value }) => {

      const { actions, history } = store.props
      if (alt && value) actions.setTriageSelectedCareOption({ name: alt, score: value })

      const { name = '' } = actions.getTriageSelectedCareOption()
      const slug = kebabCase(name)
      const resultStep = careOptionsWithoutLocations.includes(slug)
        ? slug
        : 'care-options-result'

      history.push(`/find-care-options/${resultStep}`)
      state.triageRequest.activeMenu = "care-options";
    }
  },

  async didMount({ store, state, actions }) {

    try {

      await actions.setTriageResponse({ scoreResults })
      actions.generateRecommendedCareOptions()
      store.setState({ isLoading: false })
      //actions.submitTriageSession()

    } catch(e) {

    }
  },

  withProps: ({
    store: {
      state: { viewMode },
      actions: { toggleViewMode, selectCareOption, goCareOption }
    },
    state: {
      triageResponse: { recommendedCareOptions = [] }
    },
  }) => ({
    cards: recommendedCareOptions,
    numberOfCards: recommendedCareOptions.length,
    viewMode, toggleViewMode,
    selectCareOption, goCareOption
  })

})(CareOptions)
